module.exports = __webpack_public_path__ + "img/WorkSans-ExtraBold.ed976dd.svg";